import * as React from "react";
import { AddressType } from "./admin-gql";
import { getAddressTypeDisplayNames } from "./displayNames";
export var SelectAddressType = function (props) {
    return (React.createElement("select", { className: "form-control", disabled: props.disabled || props.readonly, value: props.type, onChange: function (ev) { return props.onChange(ev.target.value); } }, Object.keys(AddressType)
        .filter(function (x) { return x !== AddressType.OFFICIAL; })
        .map(function (x) { return (React.createElement("option", { value: x, key: x }, getAddressTypeDisplayNames(x) || x)); })));
};
//# sourceMappingURL=SelectAddressType.js.map